import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class SideNavBarService {
  isFromSubMenu = false;
  private collapsedState = new BehaviorSubject<boolean>(false);
  public collapsedState$: Observable<boolean> = this.collapsedState.asObservable();

  constructor() {
  }

  navCollapsed() {
    const body = document.getElementsByTagName('body')[0];
    const classList = body?.classList;
    if (classList.contains('sidebar-enable') && classList.contains('vertical-collpsed')) {
      classList.remove('vertical-collpsed');
      classList.remove('sidebar-enable');
      this.collapsedState.next(false);
    } else {
      classList.add('vertical-collpsed');
      classList.add('sidebar-enable');
      this.collapsedState.next(true);
    }
  }


  toggleSideNavBar(index: number): void {
    if (!this.isFromSubMenu) {
      const parentMenuElements = document.getElementById(`${index}-parent`);
      const parentId = parentMenuElements?.getAttribute('id');
      const childElementId = parentId?.replace('-parent', '-child');
      const parentClassList = parentMenuElements?.classList;
      const attrs = parentMenuElements?.getElementsByTagName('a')?.[0];
      let childElementClass = document.getElementById(`${childElementId}`)?.classList;

      if (!parentClassList?.contains("mm-active")) {
        parentClassList?.add("mm-active");
      } else {
        parentClassList.value = '';
        parentClassList.add("cursor-pointer");
      }
      if (!attrs?.getAttribute("aria-expanded")) {
        attrs?.setAttribute('aria-expanded', 'true');
      } else {
        attrs?.setAttribute('aria-expanded', 'false');
      }
      if (!childElementClass?.contains("mm-show")) {
        childElementClass?.add("mm-show");
      } else {
        childElementClass.value = '';
        childElementClass.add("sub-menu");
        childElementClass.add("mm-collapse");
      }
    }
    this.isFromSubMenu = false;
  }

  handleDOMManipulation(isFromSideBar?: boolean): void {
    // Get the parent elements and their child elements by their IDs
    const parentMenuElements = document.querySelectorAll('[id$="-parent"]');

    parentMenuElements.forEach((parentElement, i) => {
      const parentId = parentElement.getAttribute('id');
      const childElementId = parentId?.replace('-parent', '-child');
      let isIncludes = false;
      if (Array.from(parentElement.childNodes)?.some(node => node.nodeName === 'UL')) {
        const childMenuElement = document.getElementById(childElementId || ''); // Changed from querySelectorAll to getElementById
        if (childMenuElement) {
          const links = childMenuElement.querySelectorAll('a[href]');
          links.forEach(link => {
            const href = link.getAttribute('href') !== '' ? link.getAttribute('href') : null;
            const classList = link.classList;
            if (href && href.includes(document.location.hash)) {
              this.isFromSubMenu = true;
              isIncludes = true;
              if (document.location.hash.includes(href)) {
                classList?.add('active');
              }
              const parentClassList = parentElement?.classList;
              if (!parentClassList?.contains("mm-active")) {
                parentClassList?.add("mm-active");
              }
              const attrs = parentElement?.getElementsByTagName('a')?.[0];
              if (attrs?.getAttribute("aria-expanded") !== 'true') {
                attrs?.setAttribute('aria-expanded', 'true');
              }
              let childElementClass = document.getElementById(`${childElementId}`)?.classList;
              if (!childElementClass?.contains("mm-show")) {
                childElementClass?.add("mm-show");
              }
            }

            if (isIncludes && href && !document.location.hash.includes(href)) {
              classList.value = '';
              classList?.add('waves-effect');
            }

            if (!isIncludes) {
              const parentClassList = parentElement?.classList;
              classList.value = '';
              classList?.add('waves-effect');
              if (parentClassList?.contains("mm-active")) {
                parentClassList.value = '';
                parentClassList.add("cursor-pointer");
              }
              const attrs = parentElement?.getElementsByTagName('a')?.[0];
              if (attrs?.getAttribute("aria-expanded")) {
                attrs?.setAttribute('aria-expanded', 'false');
              }
              let childElementClass = document.getElementById(`${childElementId}`)?.classList;
              if (childElementClass?.contains("mm-show")) {
                childElementClass.value = '';
                childElementClass.add("sub-menu");
                childElementClass.add("mm-collapse");
              }
            }
          });
        }
      } else {
        const parentClassList = parentElement.classList;
        const links = parentElement.querySelectorAll('a[href]');
        const href = links?.[0]?.getAttribute('href') !== '' ? links?.[0]?.getAttribute('href') : null;
        const classList = links?.[0]?.classList;
        if (href && (href !== '#/') && document.location.hash.includes(href)) {
          parentClassList.add('mm-active');
          classList.add('active');
        } else {
          parentClassList.value = '';
          parentClassList.add("cursor-pointer");
          classList.value = '';
        }
      }
    });
    if (isFromSideBar) {
      this.isFromSubMenu = false;
    }
  }
}
